import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {Accident, matchAccidentByType} from 'ApplicationEntry/models/ProductsRiders/Accident/Accident';
import * as G from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import * as NY from 'ApplicationEntry/models/ProductsRiders/Accident/NewYorkAccident';
import * as O from 'ApplicationEntry/models/ProductsRiders/Accident/OrdinaryAccident';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassModel,
} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';

export enum AccidentActionType {
  CHANGE_PRODUCT_TYPE = 'accident/CHANGE_PRODUCT_TYPE',
  CHANGE_PLAN_TYPE = 'accident/CHANGE_PLAN_TYPE',
  CHANGE_PREMIUM = 'accident/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'accident/CHANGE_CALCULATED_PREMIUM',
  CHANGE_MONTHLY_SALARY = 'accident/CHANGE_MONTHLY_SALARY',
  CHANGE_CWA = 'accident/CHANGE_CWA',
  CHANGE_SECTION_125 = 'accident/CHANGE_SECTION_125',
  CHANGE_SELECT_CGI = 'accident/CHANGE_SELECT_CGI',
  CHANGE_APDIR1 = 'accident/CHANGE_APDIR1',
  CHANGE_REPLACEMENT = 'accident/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'accident/CHANGE_POLICY_NUMBER',
  CHANGE_POLICY_OPTION = 'accident/CHANGE_POLICY_OPTION',
  CHANGE_RIDER_CODES = 'accident/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMOUNT = 'accident/CHANGE_RIDER_AMOUNT',
  CHANGE_OVERRIDE_BILL_FORM = 'accident/CHANGE_OVERRIDE_BILL_FORM',
  CHANGE_BASE_UNITS = 'accident/CHANGE_BASE_UNITS',
  GET_ACCIDENT_PRODUCTS = 'accident/GET_ACCIDENT_PRODUCTS',
  CHANGE_ACCIDENT_PRODUCTS = 'accident/CHANGE_ACCIDENT_PRODUCTS',
  CHANGE_RETURN_OF_PREMIUM = 'accident/CHANGE_RETURN_PREMIUM',
  CHANGE_CONTINUATION_OF_COVERAGE = 'accident/CHANGE_CONTINUATION_OF_COVERAGE',
  CHANGE_PACKAGE = 'accident/CHANGE_PACKAGE',
  CHANGE_PLAN = 'accident/CHANGE_PLAN',
  CHANGE_SITUS_STATE = 'accident/CHANGE_SITUS_STATE',
  CHANGE_J_STAMP = 'accident/CHANGE_J_STAMP',
  CHANGE_ACCIDENT_PACKAGES = 'accident/CHANGE_ACCIDENT_PACKAGES',
  GET_ACCIDENT_PACKAGES = 'accident/GET_ACCIDENT_PACKAGES',
  GET_OCC_CLASS = 'accident/GET_OCC_CLASS',
  CHANGE_OCC_CLASS = 'accident/CHANGE_OCC_CLASS',
  CHANGE_HSA = 'accident/CHANGE_HSA',
  CHANGE_COVERAGE_TIER = 'accident/CHANGE_COVERAGE_TIER',
  CHANGE_THIRD_TIER = 'accident/CHANGE_THIRD_TIER',
  CHANGE_BER_VERSION = 'accident/CHANGE_BER_VERSION',
  CHANGE_OPR_UNITS = 'accident/CHANGE_OPR_UNITS',
  CHANGE_ACCTREATURGENT = 'accident/CHANGE_ACCTREATURGENT',
  CHANGE_EMERROOMSERV = 'accident/CHANGE_EMERROOMSERV',
  CHANGE_OUTPATPHYSICIAN = 'accident/CHANGE_OUTPATPHYSICIAN',
  CHANGE_DISLOCFRACTURE = 'accident/CHANGE_DISLOCFRACTURE',
  CHANGE_ACCDEATHDIS = 'accident/CHANGE_ACCDEATHDIS',
  CHANGE_DF_VERSION = 'accident/CHANGE_DF_VERSION',
  CHANGE_BE_VERSION = 'accident/CHANGE_BE_VERSION',
  CLEAR_ACCIDENT = 'accident/CLEAR_ACCIDENT',
  CHANGE_OFF_JOB_ACCIDENT = 'accident/CHANGE_OFF_JOB_ACCIDENT',
  CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS = 'accident/ON_OFF_JOB_ACCIDENT_SICKNESS',
  CHANGE_ON_OFF_JOB_ACCIDENT = 'accident/ON_OFF_JOB_ACCIDENT',
  CHANGE_OFF_JOB_ACCIDENT_SICKNESS = 'accident/OFF_JOB_ACCIDENT_SICKNESS',
  CHANGE_ON_OFF_JOB_ACCIDENT_SPOUSE = 'accident/ON_OFF_JOB_ACCIDENT_SPOUSE',
  CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS_SPOUSE = 'accident/ON_OFF_JOB_ACCIDENT_SICKNESS_SPOUSE',
  CHANGE_EMPLOYEE_DISABILITY_RIDER = 'accident/CHANGE_EMPLOYEE_DISABILITY_RIDER',
  CHANGE_SPOUSE_DISABILITY_RIDER = 'accident/CHANGE_SPOUSE_DISABILITY_RIDER',
  CHANGE_RIDER_INFORMATION = 'accident/CHANGE_RIDER_INFORMATION',
  CHANGE_STATE = 'accident/CHANGE_STATE',
}

export const isAccidentAction = (action: any): action is AccidentAction =>
  action.type in reverseEnum(AccidentActionType);

export const changeProductType = (productType: string) =>
  createAction(AccidentActionType.CHANGE_PRODUCT_TYPE, {productType});
export const changePlanType = (planType: string) => createAction(AccidentActionType.CHANGE_PLAN_TYPE, {planType});
export const changePolicyOption = (policyOption: string) =>
  createAction(AccidentActionType.CHANGE_POLICY_OPTION, {policyOption});
export const changePremium = (premium: string) => createAction(AccidentActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(AccidentActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(AccidentActionType.CHANGE_CWA, {cwa});
export const changeMonthlySalary = (monthlySalary: string) =>
  createAction(AccidentActionType.CHANGE_MONTHLY_SALARY, {monthlySalary});
export const changeSection125 = (section125: boolean) =>
  createAction(AccidentActionType.CHANGE_SECTION_125, {section125});
export const changeSelectCgi = (selectCgi: boolean, productTypeValue: string) =>
  createAction(AccidentActionType.CHANGE_SELECT_CGI, {selectCgi, productTypeValue});
export const changeApdir1 = (apdir1: boolean) => createAction(AccidentActionType.CHANGE_APDIR1, {apdir1});
export const changeReplacement = (replacement: boolean) =>
  createAction(AccidentActionType.CHANGE_REPLACEMENT, {replacement});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(AccidentActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(AccidentActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmount = (riderAmount: number, index: number) =>
  createAction(AccidentActionType.CHANGE_RIDER_AMOUNT, {riderAmount, index});
export const changeOverrideBillForm = (overrideBillForm: boolean) =>
  createAction(AccidentActionType.CHANGE_OVERRIDE_BILL_FORM, {overrideBillForm});
export const getAccidentProducts = (applicationType: ApplicationType, family: string) =>
  createAction(AccidentActionType.GET_ACCIDENT_PRODUCTS, {applicationType, family});
export const changeAccidentProducts = (products: Async<string[]>) =>
  createAction(AccidentActionType.CHANGE_ACCIDENT_PRODUCTS, {products});
export const changeBaseUnits = (baseUnits: string) => createAction(AccidentActionType.CHANGE_BASE_UNITS, {baseUnits});
export const changeEmployeeDisabilityRider = (employee: string) =>
  createAction(AccidentActionType.CHANGE_EMPLOYEE_DISABILITY_RIDER, {employee});
export const changeSpouseDisabilityRider = (spouse: string) =>
  createAction(AccidentActionType.CHANGE_SPOUSE_DISABILITY_RIDER, {spouse});
export const changeContinuationOfCoverage = (continuationOfCoverage: boolean) =>
  createAction(AccidentActionType.CHANGE_CONTINUATION_OF_COVERAGE, {continuationOfCoverage});
export const changeReturnOfPremium = (returnOfPremium: boolean) =>
  createAction(AccidentActionType.CHANGE_RETURN_OF_PREMIUM, {returnOfPremium});
export const changePlan = (plan: string) => createAction(AccidentActionType.CHANGE_PLAN, {plan});
export const changePackage = (packageName: string) => createAction(AccidentActionType.CHANGE_PACKAGE, {packageName});
export const changeSitusState = (situsState: string) =>
  createAction(AccidentActionType.CHANGE_SITUS_STATE, {situsState});
export const changeJStamp = (jStamp: boolean) => createAction(AccidentActionType.CHANGE_J_STAMP, {jStamp});
export const getGroupAccidentPackages = (caseNumber: string, planCode: string) =>
  createAction(AccidentActionType.GET_ACCIDENT_PACKAGES, {caseNumber, planCode});
export const changeGroupAccidentPackages = (packages: Async<object[]>) =>
  createAction(AccidentActionType.CHANGE_ACCIDENT_PACKAGES, {packages});
export const changeHsa = (hsa: string) => createAction(AccidentActionType.CHANGE_HSA, {hsa});
export const changeCoverageTier = (coverageTier: string) =>
  createAction(AccidentActionType.CHANGE_COVERAGE_TIER, {coverageTier});
export const changeThirdTier = (thirdTier: string) => createAction(AccidentActionType.CHANGE_THIRD_TIER, {thirdTier});
export const changeBERVersion = (ber: string) => createAction(AccidentActionType.CHANGE_BER_VERSION, {ber});
export const changeAccUcUnits = (accTreatUrgent: string) =>
  createAction(AccidentActionType.CHANGE_ACCTREATURGENT, {accTreatUrgent});
export const changeEmerRoomSerUnits = (emerRoomSer: string) =>
  createAction(AccidentActionType.CHANGE_EMERROOMSERV, {emerRoomSer});
export const changeOutpatientPhyUnits = (outpatPhysician: string) =>
  createAction(AccidentActionType.CHANGE_OUTPATPHYSICIAN, {outpatPhysician});
export const changeDislocFracUnits = (dislocFracture: string) =>
  createAction(AccidentActionType.CHANGE_DISLOCFRACTURE, {dislocFracture});
export const changeAccDeathDisUnits = (accDeathDis: string) =>
  createAction(AccidentActionType.CHANGE_ACCDEATHDIS, {accDeathDis});
export const changeOprUnits = (outpatientPhysicianRider: string) =>
  createAction(AccidentActionType.CHANGE_OPR_UNITS, {outpatientPhysicianRider});
export const changeDFVersion = (df: string) => createAction(AccidentActionType.CHANGE_DF_VERSION, {df});
export const changeBEVersion = (beVersion: string) => createAction(AccidentActionType.CHANGE_BE_VERSION, {beVersion});
export const changeOffJobAccident = (offJobAccident: boolean) =>
  createAction(AccidentActionType.CHANGE_OFF_JOB_ACCIDENT, {offJobAccident});
export const changeOnOffJobAccidentSickness = (onOffJobAccidentSickness: boolean) =>
  createAction(AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS, {onOffJobAccidentSickness});
export const changeOnOffJobAccident = (onOffJobAccident: boolean) =>
  createAction(AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT, {onOffJobAccident});
export const changeOffJobAccidentSickness = (offJobAccidentSickness: boolean) =>
  createAction(AccidentActionType.CHANGE_OFF_JOB_ACCIDENT_SICKNESS, {offJobAccidentSickness});
export const changeOnOffJobAccidentSpouse = (onOffJobAccidentInsuredSpouse: boolean) =>
  createAction(AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SPOUSE, {onOffJobAccidentInsuredSpouse});
export const changeOnOffJobAccidentSicknessSpouse = (onOffJobAccidentSicknessInsuredSpouse: boolean) =>
  createAction(AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS_SPOUSE, {onOffJobAccidentSicknessInsuredSpouse});
export const clearAccident = () => createAction(AccidentActionType.CLEAR_ACCIDENT);
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(AccidentActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});
export const changeOccClass = (occClass: SalaryDeductionOccupationClassModel) =>
  createAction(AccidentActionType.CHANGE_OCC_CLASS, {occClass});
export const getOccClass = (caseNumber: string, plan: Plan) =>
  createAction(AccidentActionType.GET_OCC_CLASS, {caseNumber, plan});
export const changeState = (state: string) => createAction(AccidentActionType.CHANGE_STATE, {state});

export type AccidentAction =
  | ReturnType<typeof changeProductType>
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changePolicyOption>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeMonthlySalary>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeSelectCgi>
  | ReturnType<typeof changeApdir1>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmount>
  | ReturnType<typeof changeOverrideBillForm>
  | ReturnType<typeof getAccidentProducts>
  | ReturnType<typeof changeAccidentProducts>
  | ReturnType<typeof changeBaseUnits>
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changePackage>
  | ReturnType<typeof changeReturnOfPremium>
  | ReturnType<typeof changeContinuationOfCoverage>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changeGroupAccidentPackages>
  | ReturnType<typeof getGroupAccidentPackages>
  | ReturnType<typeof changeHsa>
  | ReturnType<typeof changeThirdTier>
  | ReturnType<typeof changeBERVersion>
  | ReturnType<typeof changeOprUnits>
  | ReturnType<typeof changeAccUcUnits>
  | ReturnType<typeof changeEmerRoomSerUnits>
  | ReturnType<typeof changeOutpatientPhyUnits>
  | ReturnType<typeof changeDislocFracUnits>
  | ReturnType<typeof changeAccDeathDisUnits>
  | ReturnType<typeof changeDFVersion>
  | ReturnType<typeof changeBEVersion>
  | ReturnType<typeof clearAccident>
  | ReturnType<typeof changeOnOffJobAccident>
  | ReturnType<typeof changeOnOffJobAccidentSickness>
  | ReturnType<typeof changeOffJobAccident>
  | ReturnType<typeof changeOffJobAccidentSickness>
  | ReturnType<typeof changeOnOffJobAccidentSicknessSpouse>
  | ReturnType<typeof changeOnOffJobAccidentSpouse>
  | ReturnType<typeof changeEmployeeDisabilityRider>
  | ReturnType<typeof changeSpouseDisabilityRider>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changeOccClass>
  | ReturnType<typeof getOccClass>
  | ReturnType<typeof changeState>;

type AccidentState = Accident;

export default (state: AccidentState, action: AccidentAction): AccidentState => {
  switch (action.type) {
    case AccidentActionType.CHANGE_PRODUCT_TYPE:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeProductType(action.payload.productType),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_PLAN_TYPE:
      return matchAccidentByType<Accident>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case AccidentActionType.CHANGE_PREMIUM:
      return matchAccidentByType<Accident>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case AccidentActionType.CHANGE_CALCULATED_PREMIUM:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case AccidentActionType.CHANGE_MONTHLY_SALARY:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeMonthlySalary(action.payload.monthlySalary),
        NewYork: NY.changeMonthlySalary(action.payload.monthlySalary),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_CWA:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case AccidentActionType.CHANGE_SECTION_125:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeSection125(action.payload.section125),
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
      })(state);
    case AccidentActionType.CHANGE_SELECT_CGI:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeSelectCgi(action.payload.selectCgi, action.payload.productTypeValue),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_APDIR1:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeApdir1(action.payload.apdir1),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_REPLACEMENT:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_POLICY_NUMBER:
      return matchAccidentByType<Accident>({
        Ordinary: O.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_RIDER_CODES:
      return matchAccidentByType<Accident>({
        Group: G.changeRiderCodes(action.payload.riderCode, action.payload.index),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_RIDER_AMOUNT:
      return matchAccidentByType<Accident>({
        Group: G.changeRiderAmount(action.payload.riderAmount, action.payload.index),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OVERRIDE_BILL_FORM:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeOverrideBillForm(action.payload.overrideBillForm),
        _: () => state,
      })(state);
    case AccidentActionType.GET_ACCIDENT_PRODUCTS:
      return matchAccidentByType<Accident>({
        Group: G.changePackageList(new Loading()),
        Ordinary: O.changeProductList(new Loading()),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_BASE_UNITS:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeBaseUnits(action.payload.baseUnits),
        Group: G.changeBaseUnits(action.payload.baseUnits),
        NewYork: NY.changeBaseUnits(action.payload.baseUnits),
      })(state);
    case AccidentActionType.CHANGE_RETURN_OF_PREMIUM:
      return matchAccidentByType<Accident>({
        Group: G.changeReturnOfPremium(action.payload.returnOfPremium),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_CONTINUATION_OF_COVERAGE:
      return matchAccidentByType<Accident>({
        Group: G.changeContinuationOfCoverage(action.payload.continuationOfCoverage),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_SITUS_STATE:
      return matchAccidentByType<Accident>({
        Group: G.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_J_STAMP:
      return matchAccidentByType<Accident>({
        Group: G.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_PLAN:
      return matchAccidentByType<Accident>({
        Group: G.changePlan(action.payload.plan),
        NewYork: NY.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_PACKAGE:
      return matchAccidentByType<Accident>({
        Group: G.changePackage(action.payload.packageName),
        _: () => state,
      })(state);
    case AccidentActionType.GET_ACCIDENT_PACKAGES:
      return matchAccidentByType<Accident>({
        Group: G.changePackageList(new Loading()),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OCC_CLASS:
      return matchAccidentByType<Accident>({
        Group: G.changeOccClass(action.payload.occClass),
        _: () => state,
      })(state);
    case AccidentActionType.GET_OCC_CLASS:
      return matchAccidentByType<Accident>({
        Group: G.changeOccClass(new Loading()),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ACCIDENT_PACKAGES:
      return matchAccidentByType<Accident>({
        Group: G.changePackageList(action.payload.packages),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_HSA:
      return matchAccidentByType<Accident>({
        Group: G.changeHsa(action.payload.hsa),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_THIRD_TIER:
      return matchAccidentByType<Accident>({
        Group: G.changeThirdTier(action.payload.thirdTier),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_BER_VERSION:
      return matchAccidentByType<Accident>({
        Group: G.changeBERVersion(action.payload.ber),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ACCTREATURGENT:
      return matchAccidentByType<Accident>({
        Group: G.changeAccUcUnits(action.payload.accTreatUrgent),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_EMERROOMSERV:
      return matchAccidentByType<Accident>({
        Group: G.changeEmerRoomSerUnits(action.payload.emerRoomSer),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OUTPATPHYSICIAN:
      return matchAccidentByType<Accident>({
        Group: G.changeOutpatientPhyUnits(action.payload.outpatPhysician),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_DISLOCFRACTURE:
      return matchAccidentByType<Accident>({
        Group: G.changeDislocFracUnits(action.payload.dislocFracture),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ACCDEATHDIS:
      return matchAccidentByType<Accident>({
        Group: G.changeAccDeathDisUnits(action.payload.accDeathDis),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OPR_UNITS:
      return matchAccidentByType<Accident>({
        Group: G.changeOprUnits(action.payload.outpatientPhysicianRider),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_DF_VERSION:
      return matchAccidentByType<Accident>({
        Group: G.changeDFVersion(action.payload.df),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_BE_VERSION:
      return matchAccidentByType<Accident>({
        Group: G.changeBEVersion(action.payload.beVersion),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OFF_JOB_ACCIDENT:
      return matchAccidentByType<Accident>({
        Group: G.changeOffJobAccident(action.payload.offJobAccident),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_OFF_JOB_ACCIDENT_SICKNESS:
      return matchAccidentByType<Accident>({
        Group: G.changeOffJobAccidentSickness(action.payload.offJobAccidentSickness),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT:
      return matchAccidentByType<Accident>({
        Group: G.changeOnOffJobAccident(action.payload.onOffJobAccident),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS:
      return matchAccidentByType<Accident>({
        Group: G.changeOnOffJobAccidentSickness(action.payload.onOffJobAccidentSickness),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SICKNESS_SPOUSE:
      return matchAccidentByType<Accident>({
        Group: G.changeOnOffJobAccidentSicknessSpouse(action.payload.onOffJobAccidentSicknessInsuredSpouse),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_ON_OFF_JOB_ACCIDENT_SPOUSE:
      return matchAccidentByType<Accident>({
        Group: G.changeOnOffJobAccidentSpouse(action.payload.onOffJobAccidentInsuredSpouse),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_EMPLOYEE_DISABILITY_RIDER:
      return matchAccidentByType<Accident>({
        Group: G.changeEmployee(action.payload.employee),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_SPOUSE_DISABILITY_RIDER:
      return matchAccidentByType<Accident>({
        Group: G.changeSpouse(action.payload.spouse),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_RIDER_INFORMATION:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        NewYork: NY.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        _: () => state,
      })(state);
    case AccidentActionType.CHANGE_STATE:
      return matchAccidentByType<Accident>({
        Ordinary: O.changeState(action.payload.state),
        _: () => state,
      })(state);
    case AccidentActionType.CLEAR_ACCIDENT: {
      if (state.key === 'InvalidGroupAccident' || state.key === 'ValidGroupAccident') {
        return G.EmptyGroupAccident;
      } else if (state.key === 'InvalidOrdinaryAccident' || state.key === 'ValidOrdinaryAccident') {
        return O.EmptyOrdinaryAccident;
      } else if (state.key === 'InvalidNewYorkAccident' || state.key === 'ValidNewYorkAccident') {
        return NY.EmptyNewYorkAccident;
      }

      return state;
    }
    default:
      return state;
  }
};
